import React from 'react';
import { Typography } from 'antd';
import moment from 'moment';
import { useAttachment } from '../../providers/attachment';
import getName from '../../../../helpers/getName';
import styles from './index.module.scss';

const MetaBlock = () => {
  const attachment = useAttachment();

  const { createDate, user, createWorker } = attachment;

  const creator = user || createWorker;

  return (
    <div className={styles.root}>
      {creator && (
        <div className={styles.creator}>
          <Speciality speciality={creator.specialityName} />
          <Name creator={creator} />
        </div>
      )}

      {createDate && (
        <Typography.Text>
          {moment(createDate).format('DD.MM.YYYY')}
        </Typography.Text>
      )}
    </div>
  );
};

export default MetaBlock;

function Speciality({ speciality }) {
  if (!speciality) return null;

  return (
    <Typography.Text strong ellipsis>
      {speciality}
    </Typography.Text>
  );
}

function Name({ creator }) {
  const name = getName(creator);

  if (!name) return null;

  return <Typography.Text ellipsis>{name}</Typography.Text>;
}
